"use client";
import { useCallback, useEffect, useRef, useState } from "react";
import { useIsomorphicEffect } from "@mantine/hooks";
//#region packages/@mantine/core/src/core/MantineProvider/use-mantine-color-scheme/use-provider-color-scheme.ts
function setColorSchemeAttribute(colorScheme, getRootElement) {
	const hasDarkColorScheme = typeof window !== "undefined" && "matchMedia" in window && window.matchMedia("(prefers-color-scheme: dark)")?.matches;
	const computedColorScheme = colorScheme !== "auto" ? colorScheme : hasDarkColorScheme ? "dark" : "light";
	getRootElement()?.setAttribute("data-mantine-color-scheme", computedColorScheme);
}
function useProviderColorScheme({ manager, defaultColorScheme, getRootElement, forceColorScheme }) {
	const media = useRef(null);
	const [value, setValue] = useState(() => manager.get(defaultColorScheme));
	const colorSchemeValue = forceColorScheme || value;
	const setColorScheme = useCallback((colorScheme) => {
		if (!forceColorScheme) {
			setColorSchemeAttribute(colorScheme, getRootElement);
			setValue(colorScheme);
			manager.set(colorScheme);
		}
	}, [
		manager.set,
		colorSchemeValue,
		forceColorScheme
	]);
	const clearColorScheme = useCallback(() => {
		setValue(defaultColorScheme);
		setColorSchemeAttribute(defaultColorScheme, getRootElement);
		manager.clear();
	}, [manager.clear, defaultColorScheme]);
	useEffect(() => {
		manager.subscribe(setColorScheme);
		return manager.unsubscribe;
	}, [manager.subscribe, manager.unsubscribe]);
	useIsomorphicEffect(() => {
		setColorSchemeAttribute(manager.get(defaultColorScheme), getRootElement);
	}, []);
	useEffect(() => {
		if (forceColorScheme) {
			setColorSchemeAttribute(forceColorScheme, getRootElement);
			return () => {};
		}
		if (forceColorScheme === void 0) setColorSchemeAttribute(value, getRootElement);
		if (typeof window !== "undefined" && "matchMedia" in window) media.current = window.matchMedia("(prefers-color-scheme: dark)");
		const listener = (event) => {
			if (value === "auto") setColorSchemeAttribute(event.matches ? "dark" : "light", getRootElement);
		};
		media.current?.addEventListener("change", listener);
		return () => media.current?.removeEventListener("change", listener);
	}, [value, forceColorScheme]);
	return {
		colorScheme: colorSchemeValue,
		setColorScheme,
		clearColorScheme
	};
}
//#endregion
export { useProviderColorScheme };

//# sourceMappingURL=use-provider-color-scheme.mjs.map